import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-fill-number-text-v1',
    templateUrl: './fill-number-text-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FillNumberTextV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();

    public placeholder: string = "Type a valid number here";
    public value: number | null;
    public valid: boolean = false;
    // Numeric literals with absolute values equal to 2^53 or greater 
    // are too large to be represented accurately as integers
    public maxRange: number = Number.MAX_SAFE_INTEGER; 


    ngOnInit(): void {
        // Set the value only if the provided field value is not an empty string
        if (this.fieldSubmission.serialized_value && this.fieldSubmission.serialized_value.toString().trim() !== '') {
            this.valid = this.fieldSubmission.serialized_value.toString().trim() !== ''; // Update validity
            this.value = parseInt(this.fieldSubmission.serialized_value);

        } else {
            this.valid = !this.fieldSubmission.field.mandatory;
        }
        this.emitValidity();
    }

    onValueChange(value: number ) {
        // BE CAREFUL ---- Number.MAX_SAFE_INTEGER = 9007199254740991
        // Handle the case when the field is optional and value is empty
        if (!this.fieldSubmission.field.mandatory && (value === null || value === undefined )) {
            this.valid = true;  // Set valid to true for optional empty values
            this.value = null;   // Clear the value or handle it as empty/null
        }
        // Check if the value is a valid number
        else if (typeof value === 'number' && !isNaN(value) && value <= this.maxRange) {
            this.value = value; // Update the value with the valid number
            this.valid = true;  // Set valid to true if the value is a valid number
        } 
        else {
            this.valid = false; // Set valid to false if the value is not a number
        }
        
        if(this.valid)
            this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: value});
        this.emitValidity();
    }

    // prevent letter e or E because type number input let exponential values.
    onKeydown(eventKey ) : void {
        if(eventKey.key === 'e' || eventKey.key === 'E'){
            eventKey.preventDefault();
        }
    }

    private emitValidity(): void {
        this.fieldValidityChange.emit({ id: this.fieldSubmission.field.uuid, valid: this.valid });
    }

}
